'use strict';

angular.module('docketbook').
  controller('editContactController', function(addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid) {

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.editContactFromParent = function(contactItem, cb) {
      $("#editContactModal").fadeIn(100);
      $scope.contactEditing = angular.copy(contactItem);
      var initials = "";
      if ( $scope.contactEditing.displayName ) {
        var split = $scope.contactEditing.displayName.split(' ');
        if ( split.length == 1 ) {
          initials = split[0].charAt(0).toUpperCase();
        } else if ( split.length > 1 ) {
          initials = split[0].charAt(0).toUpperCase();
          initials += split[1].charAt(0).toUpperCase();
        }
      }
      $scope.contactEditing.initials = initials;
      if ( $scope.contactEditing.addresses[0] ) {
        $scope.contactEditing.address = $scope.contactEditing.addresses[0];
      }
      var emailAddresses = [];
      for ( var emailKey in $scope.contactEditing.contactAddresses ) {
        var editable = true;
        if ( emailKey.indexOf('.on.docketbook.io') != -1 ) {
          editable = false;
        }
        var emailAddressEntry = {emailAddress:emailKey, permissions: $scope.contactEditing.contactAddresses[emailKey], editable: editable};
        emailAddresses.push(emailAddressEntry);
      }
      $scope.contactEditing.emailAddresses = emailAddresses;
      $scope.contactEditCallback = cb;
    }

    $scope.selectNewContact = function() {
      $("#editContactModal").fadeOut(100);
      $scope.contactEditCallback('select');
    }

    $scope.closeContactEdit = function() {
      $("#editContactModal").fadeOut(100);
      $scope.contactEditCallback(null);
    }

    $scope.saveContactEdit = function() {
      $("#editContactModal").fadeOut(100);
      if ( $scope.contactEditing.address ) {
        $scope.contactEditing.addresses[0] = $scope.contactEditing.address;
      }
      var contactAddresses = {};
      if ( $scope.contactEditing.emailAddresses.length > 0 ) {
        for ( var i = 0; i < $scope.contactEditing.emailAddresses.length; i++ ) {
          var addressItem = $scope.contactEditing.emailAddresses[i];
          contactAddresses[addressItem.emailAddress] = addressItem.permissions;
        }
      }
      $scope.contactEditing.contactAddresses = contactAddresses;
      $scope.contactEditCallback($scope.contactEditing);
    }

    $scope.removeEmailAddressFromContact = function(email) {
      var index = $scope.contactEditing.emailAddresses.indexOf(email);
      if ( index != -1 ) {
        $scope.contactEditing.emailAddresses.splice(index,1);
      }
    }

    $scope.addAnotherEmailAddress = function() {
      $scope.contactEditing.emailAddresses.push({emailAddress:"",permissions:['approver'], editable: true});
    }
});



// WEBPACK FOOTER //
// ./src/controllers/modals/editContactController.js